import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';
import profile from '../../../assets/images/profiles/profile.jpg';
import { AccountAddState } from '../../../interface/account-management.interface';
import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';

interface ReasonDetailInterface {
  reason: string;
}

interface DeleteAccountInterface {
  accountDetails?: AccountAddState;
  closeModal: () => void;
  conformSubmit: (value: any) => void;
}
/**
 * Delete Account function component
 * @param {any} param0 - The param0
 * @param {any} param0.accountDetails - The accountDetails prop
 * @param {any} param0.closeModal - The closeModal prop
 * @param {any} param0.conformSubmit - The conformSubmit prop
 */
function RejectAccount({ accountDetails, closeModal, conformSubmit }: DeleteAccountInterface) {
  const { t } = useTranslation('account');
  const [reasonDetails, setReasonDetails] = useState<ReasonDetailInterface>({
    reason: '',
  });

  /**
   * Input filed handle change function
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleInput = (name: string, value: string | number) =>
    setReasonDetails({
      ...reasonDetails,
      [name]: value,
    });

  return (
    <div className="add-account-form">
      <div className="view-body">
        <div className="profile-details">
          <div className="profile-image">
            <img src={profile} alt="profile" />
          </div>
          <div className="profile-user">
            <div className="profile-title-1">{accountDetails?.name}</div>
            <div className="profile-title-2">{accountDetails?.email}</div>
          </div>
        </div>
        <div className="form-field">
          <CustomInput
            type="text"
            placeholder={t('enterReason')}
            value={reasonDetails.reason}
            name="reason"
            onChangeValue={handleInput}
            inputLabel={t('enterValidReason')}
          />
        </div>
        <div className="form-field table-bottom-button-list form-bottom-button">
          <div className="table-button-item">
            <MyButton label={t('cancel')} buttonType="back" onClickFunc={() => closeModal()} />
          </div>
          <div className="table-button-item">
            <MyButton
              label={t('rejectAccount')}
              buttonType="error"
              svgBackIcon={<Delete />}
              onClickFunc={() => conformSubmit({ ...accountDetails, ...reasonDetails })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

RejectAccount.defaultProps = {
  accountDetails: {},
};

export default RejectAccount;
